module.exports = __webpack_public_path__ + "img/totalpoint-svg.4721b50c.svg";